import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

//redux data
import { agregarQuitarProductoALista } from "../../../../../redux/data/listas";
import listasSlice from "../../../../../redux/data/listas";
import { getListasDeUsuario } from "../../../../../redux/data/listas";
import modalSlice from "../../../../../redux/data/modal";

//icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faStar,
  faList,
  faTimes,
  faVideo,
} from "@fortawesome/pro-light-svg-icons";
import { faStar as fullStar } from "@fortawesome/free-solid-svg-icons";

import {
  ListaDeOpcionesSobreListas,
  ContenedorControlDeListas,
  LabelExplicatoriaDeAccion,
  BotonAgregaraLista,
} from "./ListsControlStyled";

const ListsControl = ({ producto, contexto }) => {
  /* me traigo la accion que oculta el popup de las listas desde el state */
  const { mostrarPopUpListas } = listasSlice.actions;
  const { openModal } = modalSlice.actions;
  const [opcionesDeListasVisibles, setOpcionesDeListasVisibles] =
    useState(false);
  const [esFavorito, setEsFavorito] = useState(false);

  const dispatch = useDispatch();
  const favoritos = useSelector(
    (state) =>
      state.favoritos &&
      state.favoritos.favorito &&
      state.favoritos.favorito.indiceProductos
  );

  //marco si el producto ya esta en favoritos
  useEffect(() => {
    favoritos && favoritos.includes(producto.id)
      ? setEsFavorito(true)
      : setEsFavorito(false);
    /* esto pone visibles las opciones de lista solo si se esta cargando el componente desde el detalle del producto*/
    contexto === "detalle-de-producto" && setOpcionesDeListasVisibles(true);
  }, [producto, favoritos]);

  // agregar o eliminar productos a favoritos
  const handleAgregarEliminar = (data) => {
    dispatch(agregarQuitarProductoALista(data));
    if (data.agregarProducto === 1) {
      //Solo se ejecuta evento cuando es agregar
      obtenerdataG4PorProducto(data.producto_id, addToWishlist);
      procesarFacebookConversionApi(
        JSON.stringify({
          metodo: "addToWishlist",
          prod_id: data.producto_id,
          url: location.pathname,
        })
      );
    }
  };

  const videoModalVisible = () => {
    dispatch(
      openModal({
        type: "video",
        data: producto.videos,
        titulo: producto.titulo,
        link: producto.urlseo,
      })
    );
  };

  return (
    (!contexto || opcionesDeListasVisibles || producto?.videos?.length > 0) && (
      <ListaDeOpcionesSobreListas
        contexto={contexto}
        onMouseLeave={
          !contexto
            ? () =>
                setTimeout(
                  () =>
                    setOpcionesDeListasVisibles(
                      opcionesDeListasVisibles && !opcionesDeListasVisibles
                    ),
                  1000
                )
            : undefined
        }
      >
        {!contexto && (
          <ContenedorControlDeListas>
            <BotonAgregaraLista
              contexto={contexto}
              onClick={() =>
                setOpcionesDeListasVisibles(
                  !!opcionesDeListasVisibles ? false : true
                )
              }
            >
              {!opcionesDeListasVisibles ? (
                <FontAwesomeIcon icon={faList} size={!contexto ? "lg" : null} />
              ) : (
                <FontAwesomeIcon
                  icon={faTimes}
                  size={!contexto ? "lg" : null}
                />
              )}
            </BotonAgregaraLista>
            <LabelExplicatoriaDeAccion>
              {!opcionesDeListasVisibles ? " Agregar a lista" : "Cerrar"}
            </LabelExplicatoriaDeAccion>
          </ContenedorControlDeListas>
        )}
        {/* agregar a lista personalizada */}
        {opcionesDeListasVisibles &&
          (esFavorito ? (
            <ContenedorControlDeListas>
              <BotonAgregaraLista
                contexto={contexto}
                onClick={() =>
                  handleAgregarEliminar({
                    tipo_lista: 1,
                    agregarProducto: 0,
                    producto_id: producto.id,
                  }) || setEsFavorito(!esFavorito)
                }
              >
                <FontAwesomeIcon
                  icon={fullStar}
                  size={!contexto ? "lg" : null}
                />
                {contexto && <span>Ya está en tus favoritos</span>}
              </BotonAgregaraLista>
              <LabelExplicatoriaDeAccion>
                Ya está en tus favoritos
              </LabelExplicatoriaDeAccion>
            </ContenedorControlDeListas>
          ) : (
            <ContenedorControlDeListas>
              <BotonAgregaraLista
                contexto={contexto}
                onClick={() => {
                  if (document.getElementById("usr_id") !== null) {
                    handleAgregarEliminar({
                      tipo_lista: 1,
                      agregarProducto: 1,
                      producto_id: producto.id,
                    }) || setEsFavorito(!esFavorito);
                  } else {
                    location.href = "login";
                  }
                }}
              >
                <FontAwesomeIcon icon={faStar} size={!contexto ? "lg" : null} />
                {contexto && <span>Agregar a Favoritos</span>}
              </BotonAgregaraLista>
              <LabelExplicatoriaDeAccion>
                Agregar a Favoritos
              </LabelExplicatoriaDeAccion>
            </ContenedorControlDeListas>
          ))}
        {/* agregar a favoritos */}
        {opcionesDeListasVisibles && (
          <ContenedorControlDeListas>
            <BotonAgregaraLista
              contexto={contexto}
              onClick={() => {
                if (document.getElementById("usr_id") !== null) {
                  dispatch(getListasDeUsuario(1));
                  dispatch(mostrarPopUpListas(producto.id));
                } else {
                  location.href = "login";
                }
              }}
            >
              <FontAwesomeIcon icon={faList} size={!contexto ? "lg" : null} />
              {contexto && <span>Agregar a una lista</span>}
            </BotonAgregaraLista>
            <LabelExplicatoriaDeAccion>
              Agregar a otra lista
            </LabelExplicatoriaDeAccion>
          </ContenedorControlDeListas>
        )}

        {producto && producto.videos && producto.videos.length > 0 && (
          <ContenedorControlDeListas>
            <BotonAgregaraLista
              aria-label="Ver video"
              onClick={() => videoModalVisible()}
            >
              <FontAwesomeIcon icon={faVideo} size="lg" />
            </BotonAgregaraLista>
            <LabelExplicatoriaDeAccion>Ver Video</LabelExplicatoriaDeAccion>
          </ContenedorControlDeListas>
        )}
      </ListaDeOpcionesSobreListas>
    )
  );
};

export default ListsControl;
